/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-24 11:08:06
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-11 16:29:51
 */
// 0西药套餐: 1中药套餐: 2诊疗套餐: 3颗粒剂套餐
export enum SetmealCategory {
  XYTC = 0,
  ZYTC = 1,
  ZLTC = 2,
  KLJTC = 3,
  CZXMTC = 4,
  JCTC = 5,
}

export const SetmealCategoris = [
  SetmealCategory.XYTC,
  SetmealCategory.ZYTC,
  SetmealCategory.ZLTC,
  SetmealCategory.KLJTC,
  SetmealCategory.CZXMTC,
  SetmealCategory.JCTC,
]

export function SetmealCategoryName(setmealCategory: SetmealCategory) {
  switch (setmealCategory) {
    case 0:
      return '西药套餐'
    case 1:
      return '中药套餐'
    case 2:
      return '诊疗套餐'
    case 3:
      return '颗粒剂套餐'
    case 4:
      return '处置项目套餐'
    case 5:
      return '检查套餐'
    default:
      break
  }
}

export function setMealflag(setmealCategory: SetmealCategory) {
  switch (setmealCategory) {
    case 0:
      return 1
    case 1:
      return 3
    case 2:
      return null
    case 3:
      return 2
    case 4:
      return 4
    default:
      break
  }
}

export enum TreatmentPartsCategory {
  B = 'A1',
  E = 'A2',
  QE = 'A3',
  TD = 'A4',
  ZH = 'A5',
  XE = 'A6',
  JZ = 'A7',
  YH = 'A8',
  J = 'A9',
  X = 'A10',
  FB = 'A11',
  JJQ = 'A12',
  Y = 'A13',
  JZZ = 'A14',
  SB = 'A15',
  SW = 'A16',
  SZ = 'A17',
  TB = 'A18',
  DT = 'A19',
  Q = 'A20',
  XT = 'A21',
  ZD = 'A22',
}

export const TreatmentPartsCategoris = [
  TreatmentPartsCategory.B,
  TreatmentPartsCategory.E,
  TreatmentPartsCategory.QE,
  TreatmentPartsCategory.TD,
  TreatmentPartsCategory.ZH,
  TreatmentPartsCategory.XE,
  TreatmentPartsCategory.JZ,
  TreatmentPartsCategory.YH,
  TreatmentPartsCategory.J,
  TreatmentPartsCategory.X,
  TreatmentPartsCategory.FB,
  TreatmentPartsCategory.JJQ,
  TreatmentPartsCategory.Y,
  TreatmentPartsCategory.JZZ,
  TreatmentPartsCategory.SB,
  TreatmentPartsCategory.SW,
  TreatmentPartsCategory.SZ,
  TreatmentPartsCategory.TB,
  TreatmentPartsCategory.DT,
  TreatmentPartsCategory.Q,
  TreatmentPartsCategory.XT,
  TreatmentPartsCategory.ZD,
]

export function getTreatmentPartsName(treatmentParts: TreatmentPartsCategory) {
  switch (treatmentParts) {
    case 'A1':
      return '鼻'
    case 'A2':
      return '耳'
    case 'A3':
      return '前额'
    case 'A4':
      return '头顶'
    case 'A5':
      return '枕后'
    case 'A6':
      return '下颌'
    case 'A7':
      return '颈椎'
    case 'A8':
      return '咽喉'
    case 'A9':
      return '肩'
    case 'A10':
      return '胸'
    case 'A11':
      return '腹部'
    case 'A12':
      return '肩胛区'
    case 'A13':
      return '腰'
    case 'A14':
      return '脊柱'
    case 'A15':
      return '手臂'
    case 'A16':
      return '手腕'
    case 'A17':
      return '手掌'
    case 'A18':
      return '臀部'
    case 'A19':
      return '大腿'
    case 'A20':
      return '膝'
    case 'A21':
      return '小腿'
    case 'A22':
      return '足底'
    default:
      break
  }
}
